import { render, staticRenderFns } from "./TabletMigration.vue?vue&type=template&id=abe669d8&"
import script from "./TabletMigration.vue?vue&type=script&lang=js&"
export * from "./TabletMigration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TabletMigration.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abe669d8')) {
      api.createRecord('abe669d8', component.options)
    } else {
      api.reload('abe669d8', component.options)
    }
    module.hot.accept("./TabletMigration.vue?vue&type=template&id=abe669d8&", function () {
      api.rerender('abe669d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TabletMigration.vue"
export default component.exports